import React from 'react';
import Styled from 'styled-components';
import PropTypes from 'prop-types';

export const SIZE = {
	SMALL: 'small',
	MEDIUM: 'medium',
	LARGE: 'large',
};

const StyledSpan = Styled.span`
	display: flex;
	height: ${({size}) => size + 'px'};
	width: ${({size}) => size + 'px'};
	align-items: center;
	> svg {
		path {
			fill: ${({color, overrideColor}) => overrideColor && color};
		}
	}
	&:hover	{ 
		> svg {
			path {
				fill: ${({color, hoverColor}) => (hoverColor ? hoverColor : color)};
			}
		}
	}
`;

export const BaseIcon = ({children, size = SIZE.MEDIUM, color = '#4C4C58', overrideColor, hoverColor}) => {
	const getSize = size => {
		switch (size) {
			case SIZE.SMALL:
				return 16;
			case SIZE.MEDIUM:
				return 20;
			case SIZE.LARGE:
				return 24;
		}
	};
	return (
		<StyledSpan size={getSize(size)} color={color} overrideColor={overrideColor} hoverColor={hoverColor}>
			{children}
		</StyledSpan>
	);
};

export const iconPropTypes = {
	children: PropTypes.node,
	size: PropTypes.oneOf(Object.values(SIZE)),
	color: PropTypes.string,
	overrideColor: PropTypes.bool,
	hoverColor: PropTypes.string,
};

export const iconDefaultProps = {
	size: SIZE.MEDIUM,
	color: '#4C4C58',
	overrideColor: true,
	hoverColor: '#4C4C58',
};

BaseIcon.SIZE = SIZE;
BaseIcon.propTypes = iconPropTypes;
BaseIcon.defaultProps = iconPropTypes;
